import React from 'react'
import styled from 'styled-components'
import { ModalColorTheme } from 'theme/modal/colors'
import AlchemyModal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import LanguageSelector from './LanguageSelector'

export interface LanguageSelectModalProps {
  onDismiss?: () => void
}

const LanguageSelectModal: React.FC<ModalProps<LanguageSelectModalProps>> = ({ onDismiss }) => {
  return (
    <AlchemyModal onDismiss={onDismiss} colorTheme={ModalColorTheme.Darkblue}>
      <ModalHeader colorTheme="darkblue" title="Choose Language" />
      <ModalBody>
        <StyledLanguageSelector onDismiss={onDismiss} />
      </ModalBody>
    </AlchemyModal>
  )
}

const StyledLanguageSelector = styled(LanguageSelector)`
  background: transparent;
  border: 0;
  border-radius: 0;
  margin: 0;
`

export default LanguageSelectModal
